export default __webpack_public_path__ + "static/media/runRightDark.3703010f.svg";